import React from 'react';
import Text from '../Text';
import defaultVideoMaxSize from './images/defaultVideoMaxSize.png';
import playerIcon from './images/player.svg';
import './VideoPlayer.less';

type VideoPlayerProps = {
  videoUrl?: string;
  href?: string;
  height?: string;
  width?: string;
  playerText?: string;
  onClick?: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

const TVideoPlayer: React.FC<VideoPlayerProps> = ({
  height,
  width,
  videoUrl,
  href,
  playerText,
}) => {
  return (
    <div className="t-video-player-container">
      <div
        className="t-video-player-wrapper"
        style={{ width: width, height: height }}
      >
        {videoUrl ? (
          <iframe className="t-video-player" src={videoUrl}></iframe>
        ) : (
          <div
            className="t-defaultImage-wrapper"
            style={{
              backgroundImage: `url(${defaultVideoMaxSize})`,
              backgroundSize: `${width} ${height}`,
              width: width,
              height: height,
            }}
          >
            <a href={href} target="_blank" className="t-player-wrapper">
              <img alt="player" src={playerIcon} />
              {playerText && (
                <Text textColor="dark-10" level={2}>
                  {playerText}
                </Text>
              )}
            </a>
          </div>
        )}
      </div>
    </div>
  );
};

export default TVideoPlayer;
